import React, { useEffect, useContext } from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useData, useStatus, isNormal } from 'resift';
import { useHistory } from 'react-router';
import useSource from 'pages/Directory/helpers/useSource';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SourceType } from 'types/Source';

import makeGetLatestSourceFile from 'pages/Source/fetches/makeGetLatestSourceFile';
import makeGetMappingsAttributes from 'fetches/makeGetMappingsAttributes';
import SourceContext from 'helpers/SourceContext';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';
import CircularProgress from '@material-ui/core/CircularProgress';
import SyncSettings from './SyncSettings';

import { AUTHORIZE_DATA_ACCESS_URL } from 'pages/Directory/consts';

function Container() {
  const classes = useStyles();
  const history = useHistory();
  const sourceContext = useContext(SourceContext);
  const dispatch = useDispatch();
  const { sourceInfo } = sourceContext;
  const { directoryId, sourceId, type } = sourceInfo;
  const source = useSource(sourceId);
  const baseUrl = makeSourceCreateBaseUrl(directoryId, sourceId);
  const getLatestDataCSVFile = makeGetLatestSourceFile(sourceId, 'data');
  const lastDataCSV = useData(getLatestDataCSVFile);
  const dataCsvFetchStatus = useStatus(getLatestDataCSVFile);
  const getMappingsAttributes = makeGetMappingsAttributes(sourceId);
  const mappingAttributes = useData(getMappingsAttributes);
  const mappingAttributeStatus = useStatus(getMappingsAttributes);

  useEffect(() => {
    if (
      (type === SourceType.AZURE_AD || type === SourceType.GOOGLE) &&
      !_get(source, ['authorizationStatus', 'isAuthorized'], false)
    ) {
      history.push(`${baseUrl}${AUTHORIZE_DATA_ACCESS_URL}`);
    }
  }, []);

  useEffect(() => {
    if (type === SourceType.CSV) {
      dispatch(getLatestDataCSVFile());
    }
  }, []);

  useEffect(() => {
    dispatch(getMappingsAttributes());
  }, []);

  if (!isNormal(mappingAttributeStatus)) {
    return (
      <div className={classes.loading}>
        <CircularProgress color="secondary" />
      </div>
    );
  }

  if (type !== SourceType.CSV) {
    return <SyncSettings mappingAttributes={mappingAttributes} />;
  }

  if (!isNormal(dataCsvFetchStatus)) {
    return (
      <div className={classes.loading}>
        <CircularProgress color="secondary" />
      </div>
    );
  }

  return <SyncSettings lastDataCSV={lastDataCSV} mappingAttributes={mappingAttributes} />;
}

const useStyles = makeStyles(theme => {
  return {
    loading: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
});

export default Container;
